import { render, staticRenderFns } from "./PublishingTools.vue?vue&type=template&id=bcd4e4e0&"
import script from "./PublishingTools.vue?vue&type=script&lang=js&"
export * from "./PublishingTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports